import { render, staticRenderFns } from "./FancyBox.vue?vue&type=template&id=4b0bea4a&"
import script from "./FancyBox.vue?vue&type=script&lang=js&"
export * from "./FancyBox.vue?vue&type=script&lang=js&"
import style0 from "./FancyBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0bea4a')) {
      api.createRecord('4b0bea4a', component.options)
    } else {
      api.reload('4b0bea4a', component.options)
    }
    module.hot.accept("./FancyBox.vue?vue&type=template&id=4b0bea4a&", function () {
      api.rerender('4b0bea4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/FancyBox.vue"
export default component.exports